var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0293,
    y: 0.606201,
    width: 48,
    height: 48,
    rx: 10,
    transform: "rotate(15 15.0293 0.606201)",
    fill: "#36BFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_43161_589)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 28.2695V32.4001C26 32.9601 26 33.2401 26.109 33.4541C26.2049 33.6422 26.3578 33.7952 26.546 33.8911C26.7599 34.0001 27.0399 34.0001 27.6 34.0001H31.7305M26 43H20M28 39H20M32 35.9882V43.2C32 44.8802 32 45.7202 31.673 46.362C31.3854 46.9265 30.9265 47.3854 30.362 47.673C29.7202 48 28.8802 48 27.2 48H20.8C19.1198 48 18.2798 48 17.638 47.673C17.0735 47.3854 16.6146 46.9265 16.327 46.362C16 45.7202 16 44.8802 16 43.2V32.8C16 31.1198 16 30.2798 16.327 29.638C16.6146 29.0735 17.0735 28.6146 17.638 28.327C18.2798 28 19.1198 28 20.8 28H24.0118C24.7455 28 25.1124 28 25.4577 28.0829C25.7638 28.1564 26.0564 28.2776 26.3249 28.4421C26.6276 28.6276 26.887 28.887 27.4059 29.4059L30.5941 32.5941C31.113 33.113 31.3724 33.3724 31.5579 33.6751C31.7224 33.9436 31.8436 34.2362 31.9171 34.5423C32 34.8876 32 35.2545 32 35.9882Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_43161_589",
    x: -16,
    y: -2,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_43161_589"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_43161_589",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.27197f5ff25fb02aa424602e6553e3f7.svg";
export { ForwardRef as ReactComponent };